// extracted by mini-css-extract-plugin
export var chip = "_q0-0";
export var icon = "_q0-1";
export var remove = "_q0-2";
export var removeIcon = "_q0-3";